import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { UserService } from '../loginCore/user.service';
import { UtilService } from '../util.service';
import { ClaimService } from '../claim.service';

@Injectable()
export class AuthGuard  {

  constructor(
    public afAuth: AngularFireAuth,
    public userService: UserService,
    private router: Router,
    private utilService:UtilService,private claimService:ClaimService
  ) {}

 canActivate(): Promise<boolean> {
  return new Promise((resolve) => {
    this.userService.getCurrentUser()
      .then(user => {
        console.log('Guard works. User login');
        const name = this.userService.getUserName();
        if (name == null) {
          this.claimService.getFamilyMembers()
            .subscribe(members => {
              const self = members.find(m => m.relationship === "Self");
              if (self) {
                const displayName =
                  `${self.firstName} ${self.lastName}`.trim();

                this.userService.setUserName(displayName);
              }
              resolve(true);
            },
            err => {
              console.error("Error loading family members", err);
              resolve(true); 
            });
        } else {
          resolve(true);
        }

      })
      .catch(err => {
        console.log('Guard works. User not login');
        this.router.navigate(['/login']);
        resolve(false);
      });

  });
}


}
